$(document).on('turbolinks:load',function () {
  $(".alert").delay(500).fadeOut(500);
});